import React from 'react'

import seperator from 'assets/separationLine.png'

function Separator() {
  return <img className="separator" alt="separator" src={seperator} />
}

export default Separator
